import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { CheckInErrorState } from "../models/checkins-models";

@Injectable({
  providedIn: "root",
})
export class CheckInsErrorService {
  private clientErrorState = new BehaviorSubject<CheckInErrorState>(null);

  public setClientErrorState(value: CheckInErrorState): void {
    this.clientErrorState.next(value);
  }

  public getClientErrorState$(): Observable<CheckInErrorState> {
    return this.clientErrorState.asObservable();
  }
}
